import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './index.css';

import Base from './Base';
import Customers from './Customers';
import Customer from './Customer';
import Tenants from './Tenants';
import Tenant from './Tenants/Tenant';
import FormTenant from './Tenants/Form';
import StateSpecificInterestRateForm from './Tenants/StateSpecificInterestRate/StateSpecificInterestRateForm';
import Deployments from './Tenants/Deplyments';
import Forms from './Tenants/Forms';
import EmailTemplates from './Tenants/Notifications/Emails/EmailTemplates';
import SmsTemplates from './Tenants/Notifications/Sms/SmsTemplates';
import UpdateEMailTemplates from './Tenants/Notifications/Emails/UpdateEmails';
import UpdateSmsTemplates from './Tenants/Notifications/Sms/UpdateSms';
import StateSpecificInterestRate from './Tenants/StateSpecificInterestRate/index';
import 'moment/locale/en-gb';
import * as moment from 'moment';
import Review from './Customer/Loans/Review';
import LoanDetails from './Customer/Loans/LoanDetails';
import AmortizationTable from './Customer/Loans/AmortizationTable';
import Dashboard from './Dashboard';
import Permissions from './Permissions';
import Transactions from './Customer/Transactions';

import { VERIFY_AUTHORIZATION } from './Util/userType_constants';
import Session from '../Service/Session';
import { Spin } from 'antd';
import useFetchCurrentPermissions from '../hooks/useFetchCurrentPermissions';
import ServiceCharge from './ServiceCharge';
import TransactionHistory from '../Component/Profile/TransactionHistory';
import { hot } from 'react-hot-loader';

export default hot(module)(function Admin(props) {
	const current_user_info = Session.get('CURRENT_USER_INFO');

	const { ACCESS_TO_LIST_OF_USERS, ACCESS_TO_THE_DASHBOARD, ACCESS_TO_THE_TRANSACTION, loading } =
		useFetchCurrentPermissions();

	const { isSUPER_ADMIN } = VERIFY_AUTHORIZATION(current_user_info);

	moment.locale('en-gb');

	return (
		<Base>
			<Router>
				<Switch>
					<Route component={Customer} exact path="/admin/customer/:id" />
					<Route
						exact
						path="/admin/permissions"
						component={() => <Permissions authorized={isSUPER_ADMIN} />}
					/>

					<Route component={Customer} exact path="/admin/customer/custom-view/:id" />
					<Route
						exact
						path="/admin/transactions"
						component={() =>
							loading ? (
								<div className="backdrop">
									<Spin size="large" />
								</div>
							) : (
								<Transactions
									authorized={isSUPER_ADMIN ? true : ACCESS_TO_THE_TRANSACTION ? true : false}
								/>
							)
						}
					/>
					<Route
						exact
						path="/admin/service_charge"
						component={() =>
							loading ? (
								<div className="backdrop">
									<Spin size="large" />
								</div>
							) : (
								<ServiceCharge />
							)
						}
					/>

					<Route
						exact
						path="/admin/dashboard"
						component={() =>
							loading ? (
								<div className="backdrop">
									<Spin size="large" />
								</div>
							) : (
								<Dashboard authorized={isSUPER_ADMIN ? true : ACCESS_TO_THE_DASHBOARD ? true : false} />
							)
						}
					/>
					<Route component={Review} exact path="/admin/customer/review/loan/:id" />
					<Route component={LoanDetails} exact path="/admin/customer/loan/loan-details/:id" />
					<Route component={AmortizationTable} exact path="/amortization-table/:id" />
					<Route component={Tenants} exact path="/admin/tenants" />
					<Route component={FormTenant} exact path="/admin/tenant/create" />
					<Route component={StateSpecificInterestRateForm} exact path="/admin/tenant/state/create/:id" />
					<Route component={FormTenant} exact path="/admin/tenant/edit/:id" />
					<Route component={Deployments} exact path="/admin/tenant/deployments/:id" />
					<Route component={EmailTemplates} exact path="/admin/tenant/email-templates/:id" />
					<Route component={SmsTemplates} exact path="/admin/tenant/sms-templates/:id" />
					<Route
						component={UpdateEMailTemplates}
						exact
						path="/admin/tenant/update-email-templates/:id/:key/:locale"
					/>
					<Route component={TransactionHistory} exact path="/admin/transactions/:id" />
					<Route
						component={UpdateSmsTemplates}
						exact
						path="/admin/tenant/update-sms-templates/:id/:key/:locale"
					/>
					<Route component={Forms} exact path="/admin/tenant/forms/:id" />
					<Route component={Tenant} exact path="/admin/tenant/:id" />
					<Route component={StateSpecificInterestRate} exact path="/admin/tenant/states/:id" />
					<Route
						exact
						path={`${props.match.path}`}
						component={() =>
							loading ? (
								<div className="backdrop">
									<Spin size="large" />
								</div>
							) : (
								<Customers authorized={isSUPER_ADMIN ? true : ACCESS_TO_LIST_OF_USERS ? true : false} />
							)
						}
					/>
				</Switch>
			</Router>
		</Base>
	);
});
